import CountryFlag from "components/CountryFlag";
import ImageViewer from "components/ImageViewer";
import placeholderPicture from "images/placeholderProfile.png";
import diceComLogo from "images/dice-com-logo.png";
import { SCORE_COLORS } from "constants/scoreColors";
import SvgIcon from "components/base/SvgIcon";

const getScoreColor = (ideal, score) => {
  if (ideal) {
    return SCORE_COLORS.ideal;
  }

  return SCORE_COLORS[score] ?? SCORE_COLORS[0];
};

const TalentCell = ({ hit }) => {
  const currentRole =
    hit.careers?.[0]?.title || hit.rankDetails?.content?.current_role || "";
  const score = hit.rankDetails?.score;
  const ideal = hit.rankDetails?.ideal;

  return (
    <div className="flex gap-3 items-center py-1 min-w-0">
      <div className="relative flex-shrink-0 w-12 h-12 rounded-lg overflow-hidden bg-gray-100">
        <ImageViewer
          objectKey={hit.headshotKey}
          placeholder={
            <img
              src={placeholderPicture}
              alt=""
              className="w-full h-full object-cover"
            />
          }
          className="w-full h-full object-cover"
        />
      </div>

      <div className="flex flex-col gap-0.5 flex-1 min-w-0">
        <div className="flex items-center gap-1.5 flex-wrap min-w-0">
          <p className="font-semibold text-sm text-gray-900 truncate">
            {hit.given_name} {hit.family_name}
          </p>

          {score !== undefined && (
            <div
              className="w-5 h-5 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0"
              style={{ backgroundColor: getScoreColor(ideal, score) }}
              title={ideal ? "Ideal Candidate" : `Match Score: ${score}/5`}
            >
              {score}
            </div>
          )}

          {hit.talentSource === "dice-integration" && (
            <img
              src={diceComLogo}
              alt="Dice"
              title="Talent sourced from Dice"
              className="h-4 w-4 rounded-full shrink-0"
            />
          )}

          {currentRole && (
            <span className="text-sm text-gray-500 font-normal truncate">
              · {currentRole}
            </span>
          )}
        </div>

        <div className="flex items-center gap-2 text-xs text-gray-500 min-w-0">
          <div className="flex items-center gap-1 min-w-0 truncate">
            {hit.location?.countryCode && (
              <CountryFlag
                country={hit.location.countryCode.toLowerCase()}
                size="16x12"
                className="flex-shrink-0 w-4 h-3"
              />
            )}
            <span className="truncate">{hit.listViewLocation}</span>
          </div>

          {hit.listViewRate && (
            <span className="shrink-0">{hit.listViewRate}</span>
          )}

          {hit.isUnclaimed && (
            <div className="flex gap-1.5 items-end ">
              <SvgIcon type="personNotClaimed" className="h-4.5 w-4.5" />

              <p
                className="text-gray-500"
                title="User has not yet claimed this account"
              >
                Unclaimed
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TalentCell;
